export default __webpack_public_path__ + "static/PROUD_md-b1dee31961e98ba8fbccb2d9455ef5d3.webp";